module.exports = __webpack_public_path__ + "img/18-l.75ec4353.png";